<template>
<div id="ccLogin">

  <div class="container">
  <div class="row">
  <div class="col-xs-10 offset-xs-1 col-sm-10 offset-sm-1 col-md-8 offset-md-2 col-lg-4 offset-lg-4"
  style="border:10px solid #171a26; background:rgba(19,21,31,0.7); margin-top:150px; padding:50px 0 50px 0; border-radius: 15px;">

    <div class="row">
    <div class="col-10 offset-1">

          <div v-show="box_alert" class="alert alert-danger text-center" role="alert">
            <strong v-html="this.box_alert_text"></strong>
          </div>

          <p class="text-center">
            <img :src='"../../assets/image/logo_sokker.png"' alt="Responsive image" :title='"sokkerduel"' width="180px">
          </p>

          <div class="text-center mb-4 text_amarelo" v-show="loading">
            <div class="spinner-grow spinner-grow-sm" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            Carregando
          </div>

          <div class="input-group mb-4">
            <the-mask :mask="['###.###.###-##']" masked type="text" v-model="cpf" class="form-control" placeholder="CPF" autocomplete="off"/>
          </div>

          <div class="input-group mb-4">
            <input type="password" v-model="password2" class="form-control" placeholder="Password" autocomplete="off">
          </div>

          <p class="text-right"><router-link to="/esqueceu/senha" style="color: #fff; text-decoration: underline;">Esqueci a minha password?</router-link></p>
          <br>

          <div class="row">
            <div class="col-6">
              <router-link to="/" class="btn btn-outline-danger w-100 text_15 text_bold mt_5">Voltar</router-link>
            </div>
            <div class="col-6">
              <button class="btn btn-outline-success w-100 text_15 text_bold text_verde mt_5" @click="validar()">
                <img :src='"../../assets/image/seta_direita.svg"' width="18px" style="margin-right:5px; transform: rotate(270deg);">
                Entrar
              </button>
            </div>
          </div>

          <br><br>
          <p class="text-center">
            <router-link to="/cadastro" style="color: #fff;">Cadastre-se</router-link>
          </p>
    </div>
    </div>

  </div>
  </div>
  </div>

</div>
</template>

<script>

import axios from 'axios'
import { TheMask } from "vue-the-mask";

export default {

  data () {
    return {
      cpf: null,
      password2: null,
      box_alert: false,
      box_alert_text: null,
      timer_minutos: null,
      user: {},
      loading: false,
      errors: [],
      base_url_api: process.env.BASE_URL_API,
    }
  },

  components: { TheMask },

  created(){
    localStorage.setItem("base_url_api_mobile", this.base_url_api);
  },

  methods: {

    async validar(){

          if ( this.cpf == null || this.password2 == null || this.cpf == '' || this.password2 == '') {
            this.box_alert_text = "Preencha os campos obrigatórios!";
            this.box_alert = true;
            return;
          }

          if(this.validarCPF(this.cpf) == true){

                this.loading = true;

                var body = {
                  cpf: this.cpf,
                  password2: this.password2,
                };

                axios.post(this.base_url_api+'login', body)
                .then(response => {

                  if(response.status == 200){
                        var obj = {
                          access_token: response.data.resp.token,
                          id: response.data.resp.id,
                          username: response.data.resp.username,
                          email: response.data.resp.email,
                          balance: response.data.resp.balance,
                          balance_convidado: response.data.resp.balance_convidado,
                          time: Date.now(),
                        };

                        localStorage.setItem("user", JSON.stringify(obj));

                        this.loading = false;

                        this.$router.push({ path: '/', replace: true })
                    }

                })
                .catch(e => {
                    this.box_alert = true
                    this.box_alert_text = e.response.data.msg
                    this.loading = false;
                });

          }else{
            this.box_alert_text = "CPF inválido!";
            this.box_alert = true;
            return;
          }
      },

      stop_time(){
        clearInterval(this.timer_minutos);
      },

      /*
      getIP() {
          fetch('https://api.ipify.org?format=json')
          .then(response => response.json())
          .then(data => {
            this.ip = data.ip
            this.error = null; // Limpa mensagens de erro se houver
          })
          .catch(error => {
            this.ip = null;
            this.error = 'Erro ao obter endereço IP: ' + error.message;
          });
      }
      */

  },

  destroyed(){
    clearInterval(this.timer_minutos)
    this.stop_time()
    console.log("destroi")
  }

}
</script>


// WEBPACK FOOTER //
// src/components/login/login.vue